<div
    class="sb-step-progress-header"
    [class.padding-x-8]="showOverflowArrows && (canScrollLeft || canScrollRight)"
    [ngClass]="{
        'sb-step-progress-header-overflowing': isOverflowing,
        'sb-step-progress-shadow-left': canScrollLeft,
        'sb-step-progress-shadow-right': canScrollRight
    }">
    @if (!isTouchScreenDevice && showOverflowArrows && (canScrollLeft || canScrollRight)) {
        <div class="sb-step-progress-scroll sb-step-progress-scroll-start">
            <lib-icon-button [icon]="Icon.Common.ChevronLeft" [size]="ButtonSize.Small" [kind]="ButtonKind.NeutralTertiary" [debounce]="false" [disabled]="disableLeftButton" (clicked)="ArrowClicked(true)"></lib-icon-button>
        </div>
    }
    <div #labelsContainer class="sb-step-progress-items" (scroll)="ScrollChanged()">
        @for (step of bodyComponent.tabComponentQueryList; track step.label; let idx = $index) {
            @if (!step.hidden) {
                <div #labelItem class="sb-step-item">
                    @switch (idx | method: GetStepProgressKind: selectedIndex) {
                        @case (StepProgressKind.Inactive) {
                            <div class="sb-step-item-counter sb-step-item-counter-default">
                                <p>{{idx + 1}}</p>
                            </div>
                            <ng-container *ngTemplateOutlet="stepperLabel; context:{$implicit:step, isInactive: true, isComplete: false}"></ng-container>
                        }
                        @case (StepProgressKind.Active) {
                            <div class="sb-step-item-counter sb-step-item-counter-active">
                                <p>{{idx + 1}}</p>
                            </div>
                            <ng-container *ngTemplateOutlet="stepperLabel; context:{$implicit:step, isInactive: false, isComplete: false}"></ng-container>
                        }
                        @case (StepProgressKind.Completed) {
                            <div class="sb-step-item-counter sb-step-item-counter-complete">
                                <lib-icon class="sb-step-item-icon" [icon]="Icon.Common.Check" [size]="IconSize.TwoExtraSmall"></lib-icon>
                            </div>
                            <ng-container *ngTemplateOutlet="stepperLabel; context:{$implicit:step, isInactive: true, isComplete: true}"></ng-container>
                        }
                    }
                </div>
            }
        }
    </div>
    @if (!isTouchScreenDevice && showOverflowArrows && (canScrollLeft || canScrollRight)) {
        <div class="sb-step-progress-scroll sb-step-progress-scroll-end">
            <lib-icon-button [icon]="Icon.Common.ChevronRight" [size]="ButtonSize.Small" [kind]="ButtonKind.NeutralTertiary" [debounce]="false" [disabled]="disableRightButton" (clicked)="ArrowClicked(false)"></lib-icon-button>
        </div>
    }
</div>

<ng-template #stepperLabel let-item let-inactive="isInactive" let-complete="isComplete">
    <p class="sb-step-item-label text-nowrap" [ngClass]="{'sb-step-item-label-default': inactive, 'sb-step-item-label-complete': complete}">{{item.label}}</p>
</ng-template>
